import request from '@/request/request'

// 查询组织列表
export function listDept(query) {
    return request({
        url: '/api/permission/dept/list',
        method: 'get',
        params: query
    })
}

// 查询组织详细
export function getDeptById(id) {
    return request({
        url: '/api/permission/dept/' + id,
        method: 'get'
    })
}

// 新增组织
export function addDept(data) {
    return request({
        url: '/api/permission/dept',
        method: 'post',
        data: data
    })
}

// 修改组织
export function updateDept(data) {
    return request({
        url: '/api/permission/dept/edit',
        method: 'post',
        data: data
    })
}

// 删除组织
export function delDept(id) {
    return request({
        url: '/api/permission/dept/delete/' + id,
        method: 'post'
    })
}

// 查询组织下拉树
export function deptTreeData() {
    return request({
        url: '/api/permission/dept/treeselect',
        method: 'get'
    })
}

